import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Optional complement services (Montagem, Tratamento) for the selected variant.
 *
 * @typedef {object} ComplementCartItem
 * @property {string} variantId
 * @property {number} quantity
 */
class ProductModulesComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const blockId = this.dataset.blockId;
    const selector = blockId
      ? `product-modules-component[data-block-id="${blockId}"]`
      : 'product-modules-component';

    const newComponent = event.detail.data.html.querySelector(selector);

    if (!newComponent) {
      this.setAttribute('hidden', '');
      this.replaceChildren();
      this.clearSelections();
      return;
    }

    if (newComponent.hasAttribute('hidden')) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }

    morph(this, newComponent, { childrenOnly: true });
    this.clearSelections();
  };

  /**
   * @param {number} quantity
   * @returns {ComplementCartItem[]}
   */
  getSelectedComplementItems(quantity) {
    /** @type {ComplementCartItem[]} */
    const items = [];
    const checkboxes = this.querySelectorAll('.product-modules__checkbox-input:checked:not(:disabled)');

    checkboxes.forEach((checkbox) => {
      if (!(checkbox instanceof HTMLInputElement)) return;

      const variantIds = checkbox.dataset.variantIds?.split(',').filter(Boolean) ?? [];
      variantIds.forEach((variantId) => {
        items.push({
          variantId: variantId.trim(),
          quantity,
        });
      });
    });

    return items;
  }

  clearSelections() {
    this.querySelectorAll('.product-modules__checkbox-input').forEach((checkbox) => {
      if (checkbox instanceof HTMLInputElement) {
        checkbox.checked = false;
      }
    });
  }
}

if (!customElements.get('product-modules-component')) {
  customElements.define('product-modules-component', ProductModulesComponent);
}
